import React, { useEffect, useState } from "react";
import { fetchData } from "../../Components/common/utils";
import { NavLink, useParams, useLocation } from "react-router-dom";
import MainLoader from "../../Components/MainLoader";
function EProductList() {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [latestProducts, setLatestProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryName, setCategoryName] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const { id } = useParams();
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/electronic/product/" + id;
      const result = await fetchData(url);
      if (result && result.data) {
        const sortedData = result.data.sort((a, b) =>
          new Date(b.updated_at) - new Date(a.updated_at)
        );
        if (result.data.length >= 1) {
          setCategoryName(result.data[0].category)
        }
        setData(sortedData);
        setFilteredData(sortedData);
        setLatestProducts(sortedData.slice(0, 6));
      }
      setLoading(false);
    };
    fetchApiData();
  }, [location.pathname]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, data]);

  return (
    <div className="mt-4">
      {loading && <MainLoader />}
      {data.length === 0 ? (
        <div className="container">
          <div className="text-center no-found-text">
            <h3>Sorry! No Product Found.</h3>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="mt-4">
            {/* Modern Header */}
            <div className="brand-banner py-3 px-3 text-center text-white mb-4">
              <h1 className="display-4 fw-bold mb-2">Welcome to <span className="brand-name">{categoryName?.title}</span></h1>
              <p className="lead">{categoryName?.description}</p>
            </div>
          </div>
          <h2 className="my-3">Latest Products</h2>
          <div className="row">
            {latestProducts.map((details, index) => (
              <div className="col-md-3 mb-3" key={index}>
                <NavLink to={`${details.slug}`}>
                  <div className="card h-100">
                    <div className="card-img-wrapper">
                      <img className="latest-product-img" src={details.media[0].original_url} alt={details.title} />
                    </div>
                    <div className="card-body text-center">
                      <h6 className="card-title text-center">{details.title}</h6>
                      <p className="small product-card-description text-center">{details.short_description}</p>
                      <strong className="dollar ">{details.price}</strong>
                    </div>
                  </div>
                </NavLink>

              </div>
            ))}
          </div>
          <div className="row my-4">
            <div className="col-md-6 mt-2">
              <h2>All Products</h2>
            </div>
            <div className="col-md-6 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            {filteredData.map((details, index) => (
              <div className="col-md-3 mb-3" key={index}>
                <NavLink to={`${details.slug}`}>
                  <div className="card h-100">
                    <div className="card-img-wrapper">
                      <img className="latest-product-img" src={details.media[0].original_url} alt={details.title} />
                    </div>
                    <div className="card-body text-center">
                      <h6 className="card-title text-center">{details.title}</h6>
                      <p className="small product-card-description text-center">{details.short_description}</p>
                      <strong className="dollar ">{details.price}</strong>
                    </div>
                  </div>
                </NavLink>

              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default EProductList;